import { Typography } from '@mui/material'
import { colorTokens } from '../../../../shared/styles/theme'

/**
 * 行の中に出す一言。入力のヒントと、保存・報告が通らなかったことに使う。
 *
 * **失敗は toast にしない**(03-patterns/modals.md・wl/16)。どの項目が通らなかったかは
 * 行の中でしか言えないので、値のすぐ下に置く。**色で重要度を出さない**
 * (00-principles/04-color-discipline.md §4)。字を小さくして沈めるだけにする。
 */
export const Note = ({ children }: { children: string }) => (
  <Typography sx={{ mt: 0.25, fontSize: 11, color: colorTokens.fg.muted }}>
    {children}
  </Typography>
)
